import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import { forgotPasswordValidator } from "../utils/validators/forgotPassword";
import ForgotPasswordForm from "./forms/ForgotPasswordForm";
import { useLocation } from "react-router";

export default function ForgotPasswordWidget() {
  const {
    actions: { sendPasswordResetEmail },
  } = useAuth();

  const { state: { email } = {} } = useLocation<{ email?: string }>();

  return (
    <Form
      onSubmit={sendPasswordResetEmail}
      validate={forgotPasswordValidator}
      component={ForgotPasswordForm}
      initialValues={{
        email,
      }}
    />
  );
}
